import { useCallback } from 'react';

import { useLocation } from 'react-router';

import type { MenuItem } from '../components/MenuListItem/types';

export const useMenuItemActive = () => {
  const { pathname } = useLocation();

  const isMenuItemActive = useCallback(
    (item: MenuItem) => {
      if (!item.path) return false;

      if (item.highlightMustBeExactMatch) {
        return pathname === item.path;
      }

      if (
        item.path.startsWith('/Reports/') &&
        pathname.startsWith('/Reports/')
      ) {
        /*
          When on /ExpenseReportSubmitPrint, only that exact menu item should
          be active (handled with highlightMustBeExactMatch case),
          so the general /Reports should return false
        */
        const isOnExpenseReportSubmitPrint =
          pathname === '/Reports/Personal/ExpenseReportSubmitPrint';
        return isOnExpenseReportSubmitPrint ? false : true;
      }

      return pathname.startsWith(item.path);
    },
    [pathname],
  );

  const isExpandableItemActiveFallback = useCallback(
    (item: MenuItem) => {
      if (
        !item.additionallyHighlightingPaths ||
        item.additionallyHighlightingPaths.length === 0
      ) {
        return false;
      }

      return item.additionallyHighlightingPaths.some((path) => {
        const pathContainsWildcard = path.includes('*');

        if (pathContainsWildcard) {
          // Convert wildcard pattern to regex
          const regexPattern = path.replace(/\*/g, '[^/]+');
          const regex = new RegExp(`^${regexPattern}$`);
          return regex.test(pathname);
        }
        return pathname.startsWith(path);
      });
    },
    [pathname],
  );

  return { isMenuItemActive, isExpandableItemActiveFallback };
};
